// import React from "react";
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
// import SettingsIcon from '@material-ui/icons/Settings';
// import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import StoreIcon from '@material-ui/icons/Store';
// import DateRangeIcon from '@material-ui/icons/DateRange';
import PhotoIcon from '@material-ui/icons/Photo';
import CalendarIcon from '@material-ui/icons/Today';

import Home from "../views/Home/Home";
import HomeCalendar from "../views/Home/HomeCalendar";
import SessioneScatti from '../views/GestioneScatti/SessioneScatti';
import CloseAndSend from '../views/GestioneScatti/CloseAndSend';
import Project from '../views/RicercaProgetto/Project';
import Configuration from '../views/Settings/Configuration';
import CalendarConfiguration from "../views/Calendar/CalendarConfiguration";
import CalendarManagement from "../views/Calendar/GestioneCalendar";


let homeRoutes = [

    {
        collapse: true,
        state: "albumCollapse",
        icon: PhotoIcon,
        name: 'Album',
        views: [
            {
                path: "/album-configuration",
                label: "sb_config",
                name: "Configuration",
                component: Configuration,
                invisible: false,
                show: true,
                layout: "/photo-selfie"
            },
            {
                path: "/sessione-scatti",
                label: "sb_sessione_scatti",
                name: "Sessione Scatti",
                component: SessioneScatti,
                layout: "/photo-selfie",
                show: false
            },
            {
                path: "/chiudi",
                label: "sb_close_and_send",
                name: "Chiudi e invia",
                component: CloseAndSend,
                layout: "/photo-selfie",
                show: false,
            }
        ]
    },

    {
        collapse: true,
        state: "calendarCollapse",
        icon: CalendarIcon,
        name: 'Calendario',
        views: [
            {
                path: "/home-calendar",
                name: "Configurazione",
                label: 'sb_calendar_config',
                layout: "/photo-selfie",
                component: HomeCalendar,
                show: false

            },
            {
                path: "/calendar-management",
                name: "Gestione Calendari",
                label: 'sb_calendar_management',
                show: false,
                component: CalendarManagement,
                layout: "/photo-selfie",
            }
        ]
    },

    // {
    //     collapse: true,
    //     label: "sb_gestione_scatti",
    //     name: "Gestione scatti",
    //     icon: InsertDriveFileIcon,
    //     state: "pageCollapse",
    //     views: [
    //         {
    //             path: "/sessione-scatti",
    //             label: "sb_sessione_scatti",
    //             name: "Sessione Scatti",
    //             mini: "",
    //             component: SessioneScatti,
    //             layout: "/photo-selfie",
    //             show: false
    //         },
    //         {
    //             path: "/chiudi",
    //             label: "sb_close_and_send",
    //             name: "Chiudi e invia",
    //             mini: "",
    //             component: CloseAndSend,
    //             layout: "/photo-selfie",
    //             show: false,
    //         }
    //     ]
    // },
    {
        path: "/home",
        label: "sb_config",
        name: "Home",
        icon: InsertPhotoIcon,
        component: Home,
        invisible: false,
        show: true,
        layout: "/photo-selfie"
    },

    // {
    //     path: "/home-calendar",
    //     label: "sb_selfie_album",
    //     name: "HomeCalendar",
    //     icon: InsertPhotoIcon,
    //     component: HomeCalendar,
    //     invisible: false,
    //     show: true,
    //     layout: "/photo-selfie"
    // },
    {
        path: "/calendar-configuration",
        name: "Configurazione",
        label: 'sb_calendar_config',
        layout: "/photo-selfie",
        component: CalendarConfiguration,
        show: true,
        invisible: false

    },
    {
        path: "/project",
        label: "prj_title",
        name: "Project",
        icon: StoreIcon,
        component: Project,
        invisible: false,
        show: false,
        layout: "/photo-selfie"
    },
    {
        redirect: true,
        path: "/",
        to: "/home",
        // to: "/login",
        navbarName: "Redirect"
    }
];
export default homeRoutes;



// WEBPACK FOOTER //
// ./src/routes/home.jsx